import React, { useContext, useState } from 'react'
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavbarText
} from 'reactstrap';
import { observer } from 'mobx-react-lite';
import { NavLink } from 'react-router-dom';
import UserInfo from '../user/UserInfo';

import { history } from '../../indexMsal';
import { RootStoreContext } from '../../App/stores/RootStore';
import RoleRules from '../../App/enumerable/RolesRules';

const NavBar: React.FC = () => {
    const rootStore = useContext(RootStoreContext)
    const { user, HasRoles } = rootStore.userStore;
    const [isOpen, setIsOpen] = useState(false);
    const { REACT_APP_VERSION } = process.env;

    const toggle = () => setIsOpen(!isOpen);
    return (
        <Navbar color="dark" dark expand="md">
            <NavbarBrand onClick={() => history.push("/")}>
                <img src='/assets/RLLogoLarge_GSA2.png' alt='logo' style={{ marginRight: '10px', height: '30px' }} />
                <label style={{ fontWeight: "bolder", fontSize: "large" }}>URD</label>
                <label className="ml-2">{REACT_APP_VERSION}</label>
            </NavbarBrand>

            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className="mr-auto" navbar>
                    <NavItem>
                        <NavLink to='/Requests'>Requests</NavLink>
                    </NavItem>
                    {HasRoles(RoleRules.ReviewerAdmin) ? <NavItem>
                        <NavLink to='/RequestReviews'>Request Reviews</NavLink>
                    </NavItem> : ""}

                    {HasRoles(RoleRules.ReviewerAdmin) ? <NavItem>
                        <NavLink to='/Notes'>Notes</NavLink>
                    </NavItem> : ""}

                    {HasRoles(RoleRules.SystemAdmin) ? <NavItem>
                        <NavLink to='/Admin'>Admin</NavLink>
                    </NavItem> : ""}

                    {HasRoles(RoleRules.URDIAccess) ? <NavItem>
                        <NavLink to='/Changelog'>Changelog</NavLink>
                    </NavItem> : ""}
                </Nav>
                <NavbarText>{user && <UserInfo />}</NavbarText>
            </Collapse>
        </Navbar>
    )
}
export default observer(NavBar);